import RoutesMap from '../../route_control/RouteControl'
import {
    InviteStudentList,
    AddInviteStudent,
    StudentInstituteEnrollmentList,
    AddStudentInstituteEnrollment,
    UpdateStudentInstituteEnrollment
} from '../../pages/registration'

export const RegistrationRouteImport = {
    RoutesMap,
    InviteStudentList,
    AddInviteStudent,
    StudentInstituteEnrollmentList,
    AddStudentInstituteEnrollment,
    UpdateStudentInstituteEnrollment,
}
